import { render, staticRenderFns } from "./ModalComp.vue?vue&type=template&id=4c40d19a&scoped=true&"
import script from "./ModalComp.vue?vue&type=script&lang=js&"
export * from "./ModalComp.vue?vue&type=script&lang=js&"
import style0 from "./ModalComp.vue?vue&type=style&index=0&id=4c40d19a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40d19a",
  null
  
)

export default component.exports